/**
 * @description 获取端口
 * @returns {string}
 */
export const addressBarPort = (): string => location.port
